import { Component, HostListener } from '@angular/core';
import { WdxSwitchModule } from '@wdx/shared/components/wdx-switch';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface SwitchRendererValue {
    toggled: boolean;
    disabled?: boolean;
    label?: string;
    toggleCallBack?: (on: boolean, id: string) => void;
}

@Component({
    selector: 'wdx-ag-grid-switch-cell-renderer',

    imports: [WdxSwitchModule],
    template:
        '<wdx-switch [toggled]="toggled" [label]="label" [disabled]="disabled" (toggledChanged)="onToggle($event)"></wdx-switch>',
    host: { class: 'align-items-center d-flex h-100' },
})
export class SwitchRendererComponent implements ICellRendererAngularComp {
    @HostListener('click', ['$event'])
    public onClick(event: Event): void {
        event.stopPropagation();
    }

    public url?: string;
    public toggled?: boolean;
    public disabled?: boolean;
    public label?: string;
    public toggleCallBack?: (on: boolean, id: string) => void;
    private id?: string;

    public agInit(params: ICellRendererParams<any, SwitchRendererValue>): void {
        this.id = params.data.id;
        if (params?.value) {
            this.toggled = params.value.toggled;
            this.disabled = params.value.disabled;
            this.label = params.value.label;
            this.toggleCallBack =
                params.value.toggleCallBack || (() => undefined);
        }
    }

    public refresh(
        params: ICellRendererParams<any, SwitchRendererValue>,
    ): boolean {
        this.agInit(params);
        return true;
    }

    public onToggle(on: boolean): void {
        this.toggleCallBack && this.toggleCallBack(on, this.id as string);
    }
}
